import { CalenderEventFieldsFragment } from '__generated__/graphql';
import { TrendingUp } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { EventHeader, EventInfo } from '../../common/Common/EventHeader';
import PopularEventLabel from '../../common/PopularEventLabel';
import UI from '../../common/UI';
import useLocale from '../../common/useLocale';

interface EventCardProps {
  event: CalenderEventFieldsFragment;
}

export const EventCard = ({ event }: EventCardProps) => {
  const { t } = useTranslation();
  const { locale } = useLocale();

  return (
    <UI.NavCard
      href={`${event.checkout_url}?locale=${locale}`}
      sc={{ hasPanels: true, spacing: 'sm', flex: { direction: 'column', alignItems: 'space-between' } }}
      title={event.title}
    >
      <UI.Div sc={{ relative: true }} style={{ padding: 0, margin: -1, overflow: 'hidden' }}>
        <EventHeader
          headerUrl={event.header_url}
          size={900}
          sportType={event.sport_types[0]}
          sc={{ padding: 0, borderRadius: 'none' }}
          color={event.brand_color}
          alt={event.title}
        />
        {event.trend_score >= 60 && (
          <UI.Div
            sc={{
              absolute: true, padding: 3, small: true,
            }}
            style={{ top: 0, left: 0 }}
          >
            <PopularEventLabel>
              <UI.Icon>
                <TrendingUp />
              </UI.Icon>
              {' '}
              {t('website.popular')}
            </PopularEventLabel>
          </UI.Div>
        )}
      </UI.Div>
      <UI.Div style={{ minWidth: 0 }}>
        <UI.FlexContainer sc={{ justifyContent: 'space-between' }}>

          <UI.H3 sc={{ fontSize: 2, my: 0.25 }} style={{ fontWeight: 700 }}>
            <UI.Truncate>
              {event.title}
            </UI.Truncate>
          </UI.H3>
        </UI.FlexContainer>
        <EventInfo
          event={{
            ...event,
            location: {
              ...event.location,
              id: null,
            },
          }}
          direction="column"
        />
      </UI.Div>
    </UI.NavCard>
  );
};

export default undefined;
